import React, { useCallback, useRef, useState } from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import omit from 'lodash/omit';
import some from 'lodash/some';
import isEmpty from 'lodash/isEmpty';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';
import Button from 'chameleon/ui-stack/ui/base/button';
import useNavigation from 'chameleon/ui-stack/hooks/useNavigation';
import ContactUsPreapForm from './ContactUsPreapForm';
import sendMessage from './SendMessage';

/**
 * This component is a PREAP specific copy of the AP ContactUs form
 * chameleon/src/components/ContactUs/
 * This component was created with minimum modifications from the copy to
 * provide better refactoring and readability of both components
 *
 * @param router
 * @param userData
 * @param subjectData
 * @returns {JSX.Element}
 * @constructor
 */
const ContactUsPreap = ({ router, userData, subjectData }) => {
  const formValuesRef = useRef({});
  const [isPrimaryBtnDisabled, setIsPrimaryBtnDisabled] = useState(true);
  const contactUsFormRef = useRef();
  const { replaceParamsInLocation } = useNavigation({
    router,
  });

  const onClose = useCallback(() => {
    router.push(
      replaceParamsInLocation({
        ...omit(router.location.query, 'contactus'),
      }),
    );
  }, [router, replaceParamsInLocation]);

  const onClearFormClick = useCallback(() => {
    contactUsFormRef.current.clearForm();
    formValuesRef.current = {};
  }, [contactUsFormRef]);

  const onFormChange = useCallback((values) => {
    //If we find one value in the form empty, disable the primary button
    setIsPrimaryBtnDisabled(some(values, (value) => isEmpty(value)));
    formValuesRef.current = values;
  }, []);

  const onSendMessage = useCallback(() => {
    setIsPrimaryBtnDisabled(true);
    sendMessage(
      formValuesRef.current,
      contactUsFormRef.current.getUploadedFiles(),
      userData,
      subjectData,
    )
      .then(() => {
        router.push(
          replaceParamsInLocation({
            ...omit(router.location.query, 'contactus'),
          }),
        );
      })
      .finally(() => {
        setIsPrimaryBtnDisabled(false);
      });
  }, [userData, subjectData]);

  return (
    <ConfirmDialog
      size="medium"
      title="Contact"
      onSuccess={onSendMessage}
      onClose={onClose}
      isPrimaryBtnDisabled={isPrimaryBtnDisabled}
      content={{
        btnPrimary: 'Submit',
        btnSecondary: 'Cancel',
        bottomLeftContent: (
          <Button isNaked isLink onClick={onClearFormClick} className="mr-auto">
            Clear all
          </Button>
        ),
      }}
    >
      <div className="grid grid-cols-3 gap-x-6 gap-y-5">
        <ContactUsPreapForm
          onFormChange={onFormChange}
          ref={contactUsFormRef}
        />
      </div>
    </ConfirmDialog>
  );
};

export default compose(withRouter)(ContactUsPreap);
